export default __webpack_public_path__ + "static/media/clock-white.5674d00a.svg";